import React from 'react';
import type { FC } from 'react';
import { Text, useInput, Key } from '@wix/cli-ui-kit';
import { ScreenState } from './screen-state.js';
import { useWixCliAppBi } from '../../../bi-app/index.js';

export const SwitchSite: FC<{
  onScreenChange: (screen: ScreenState) => void;
}> = ({ onScreenChange }) => {
  const bi = useWixCliAppBi();

  useInput(async (input) => {
    if (input === 'c') {
      bi.cliAction({
        question: 'Switch development site',
        questionKey: 'dev_command.dev_site.change',
        action: 'change_site',
        key: input,
      });
      onScreenChange(ScreenState.SiteSelector());
    }
  });

  return (
    <Text skin="secondary">
      (Press <Key value="C" skin="secondary" /> to switch)
    </Text>
  );
};
